
export const NAIL_SHOP_INFO = {
  ggMapUrl: "https://maps.app.goo.gl/FwhuDkFisaQN5zvC9",
  address: "5 Westlegate, Norwich NR1 3LT, United Kingdom",
  email: "thenailcitynorwich@gmail.com",
  tel: "+441603352710",
  phone: "+44 160 335 2710",
  name: "The Nail City",
  bookingUrl: "https://thenailcity.setmore.com?source=easyshare",
  facebookId: "61565577265440",
  instagramName: "thenail_citynorwich",
  openingTime: {
    openTime: { weekdays: "Monday - Saturday", time: "09:30 - 18:30" },
    closeTime: { weekdays: "Sunday & Bank Holiday", time: "Closed" },
  },
  ggMapIframeUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d605.471390579608!2d1.2937303286241837!3d52.6259120982483!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d9e300646cd2ed%3A0xe5d792adf628aacb!2sThe%20Nail%20City!5e0!3m2!1sen!2s!4v1728455450668!5m2!1sen!2s"
};
NAIL_SHOP_INFO.instagram = `https://www.instagram.com/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.instagramChatUrl = `https://ig.me/m/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.facebook = `https://www.facebook.com/${NAIL_SHOP_INFO.facebookId}`;
NAIL_SHOP_INFO.facebookMessengerUrl = `http://m.me/${NAIL_SHOP_INFO.facebookId}`;

export const SOLCO_INFO = {
  facebook: "https://www.facebook.com/solcoagency.marketing",
  website: "https://solcomarketing.com",

  huaCatLuongWebsite: "https://huacatluong.com",
};

export const LANGUAGE_ID = {
  vi: "vi",
  en: "en",
};

export const CUSTOMER_FEEDBACK = [
  {
    name: "Olivia Taylor",
    feedback:
      "Ã¢â‚¬Å“A truly luxurious experience! The team took their time to make sure my nails were perfect. The salon is spotless, and the attention to detail is incredible. I couldnÃ¢â‚¬â„¢t be happier with the results!Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/HDBW1Xg.png",
  },
  {
    name: "Emily Johnson",
    feedback:
      "Ã¢â‚¬Å“My first time visiting, and it wonÃ¢â‚¬â„¢t be the last. The staff was friendly, and the atmosphere was calm and inviting. I left with the most beautiful nails, and the pricing was very reasonable.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/sU1i6Sk.png",
  },
  {
    name: "Sophia Martinez",
    feedback:
      "Ã¢â‚¬Å“This is the cleanest and most comfortable nail salon IÃ¢â‚¬â„¢ve ever been to. The staff are skilled professionals, and the quality of work they do is fantastic. I highly recommend their services!Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/4fmU1oA.jpeg",
  },
  {
    name: "Ava Brown",
    feedback:
      "Ã¢â‚¬Å“I always feel welcomed here! The nail techs are friendly and patient, taking the time to understand what I want. The end result is always stunning, and IÃ¢â‚¬â„¢ve received so many compliments on my nails.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/aCEUi1W.png",
  },
  {
    name: "Mia Thompson",
    feedback:
      "Ã¢â‚¬Å“A hidden gem in the city! From the moment I walked in, I knew I was in good hands. The staff is professional and the atmosphere is so relaxing. I canÃ¢â‚¬â„¢t wait for my next visit.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/F7M14q2.png",
  },
  {
    name: "Charlotte Harris",
    feedback:
      "Ã¢â‚¬Å“My nails have never looked better! The staff were attentive and made sure everything was perfect before I left. The salon is beautifully decorated, making it a relaxing space to unwind.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/KxhUFKM.jpg",
  },
  {
    name: "Amelia Clark",
    feedback:
      "Ã¢â‚¬Å“This salon exceeded all my expectations. The staff are true artists, and they give great advice on how to keep my nails healthy between visits. ItÃ¢â‚¬â„¢s always a pleasure coming here.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/kI3rsKc.jpg",
  },
  {
    name: "Isabella Evans",
    feedback:
      "Ã¢â‚¬Å“I treated myself to a manicure and pedicure here, and it was a delightful experience. The staff made me feel so comfortable, and my nails have never looked so good. I will definitely return!Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/92gXkP8.jpg",
  },
]

export const MENU_HEADER = [
  { name: "Home", navigationKey: "home" },
  { name: "About Us", navigationKey: "about-us" },
  { name: "Services", navigationKey: "services" },
  { name: "Booking", navigationKey: NAIL_SHOP_INFO.bookingUrl },
  // { name: "Contacts", navigationKey: "contactsRef" },
  { name: "Contact", navigationKey: "contact-us" },
  { name: "Policy", navigationKey: "policy" },
];
